module.exports = __webpack_public_path__ + "build/desktop/a/img/crown.44d1bff12d5b00e081cd7277263c91d3.svg";